import React, { FunctionComponent } from 'react';
import CallErrorMessage, { Severity } from 'app/components/call/CallErrors/CallErrorMessage';
import { usePeers } from 'app/containers/rtc/PeersContext';
import { useI18n } from 'app/components/localization';

// The number of peers allowed before warning the users that they might experience issues
const WARNING_REQUIRED_PARTICIPANT_COUNT = 6;

const ParticipantCountErrorMessage: FunctionComponent = () => {
  const { t } = useI18n();
  const peers = usePeers();

  // The total number of participants on the call is (number of peers) + 1
  if (peers.size + 1 <= WARNING_REQUIRED_PARTICIPANT_COUNT) {
    return null;
  }

  return (
    <CallErrorMessage severity={Severity.Info}>
      {t('rtc.errors.participant-count', { participantLimit: WARNING_REQUIRED_PARTICIPANT_COUNT })}
    </CallErrorMessage>
  );
};

export default ParticipantCountErrorMessage;
